import React from 'react';
import { Circle } from '@react-google-maps/api';

const MILES_TO_METRES = 1609.34;

const RINGS = [
  { miles: 1, color: '#3b82f6', label: '1 mi' },
  { miles: 3, color: '#8b5cf6', label: '3 mi' },
  { miles: 5, color: '#6366f1', label: '5 mi' },
];

const RadiusRingLayer = ({ center }) => {
  if (!center || center.lat == null || center.lng == null) return null;

  return (
    <>
      {RINGS.map(({ miles, color }) => (
        <Circle
          key={`ring-${miles}`}
          center={center}
          radius={miles * MILES_TO_METRES}
          options={{
            fillColor: 'transparent',
            fillOpacity: 0,
            strokeColor: color,
            strokeOpacity: 0.5,
            strokeWeight: 2,
            clickable: false,
            zIndex: 0,
          }}
        />
      ))}
    </>
  );
};

export default RadiusRingLayer;
export { RINGS };
